const firstLetterUppercase = (string: string) => {
  const _string = typeof string === "string" ? string : "";
  const uppercaseFirstLetter =
    _string.charAt(0).toUpperCase() + _string.slice(1);
  return uppercaseFirstLetter;
};

export default firstLetterUppercase;
